// src/components/Auth/ProtectedRoute.jsx
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  isAuthenticated,
  saveRedirectUrl,
  saveAdminToken,
  clearAdminToken,
} from "../../utils/storage";
import { extractProjectLink } from "../../utils/linkNormalizer";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const params       = new URLSearchParams(location.search);
  const urlToken     = params.get("token");
  const urlUpdatedBy = params.get("updatedby");

  // ─── ADMIN FLOW ───────────────────────────────────────────────────────────
  // URL mein token aaya hai → Admin request hai
  // Token save karo aur seedha andar jaane do
  useEffect(() => {
    if (urlToken) {
      saveAdminToken(urlToken, urlUpdatedBy);
    }
  }, [urlToken, urlUpdatedBy]);

  if (urlToken) {
    return children;
  }

  // ─── CUSTOMER FLOW ────────────────────────────────────────────────────────
  // URL mein token nahi hai → Customer request hai
  //
  // Important: Agar browser mein pehle se admin token pada hai (stale session),
  // usse clear karo. Customer ke liye sirf OTP-based auth (mmh_user_auth) valid hai.
  // Ye ensure karta hai ki PlanningFormPage mein customer ka token use ho,
  // admin ka nahi.
  clearAdminToken();

  // Ab check karo: kya customer OTP se already logged in hai?
  if (!isAuthenticated()) {
    // Double slash normalize karo (e.g. "//planning/PRJ" → "/planning/PRJ")
    const normalizedPath = location.pathname.replace(/\/+/g, "/");
    const intendedUrl    = normalizedPath + location.search;

    // Chahe link path-param ("/planning/PRJx") ho ya query-param
    // ("/planning?projectId=PRJx"), dono ko hamesha ek hi canonical form
    // mein save karo. Isse OTP verify ke baad check consistent rehta hai.
    // Agar ye home page ("/") jaisa non-project URL hai to canonical nahi
    // banega — us case mein raw intendedUrl hi save karo (OTP page usko
    // authentic nahi maanega, jo sahi behavior hai).
    const canonicalUrl = extractProjectLink(intendedUrl);
    saveRedirectUrl(canonicalUrl || intendedUrl);
    return <Navigate to="/login" replace />;
  }

  // Customer OTP auth valid hai → andar jaane do
  return children;
}